// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconList: React.FC = () => {
    return (
        <svg
            width="10px"
            height="9px"
            viewBox="0 0 10 9"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="currentColor"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="Interactive-Elements/Icon-+-Text/UI-:-Action-:-Template-:-Small"
                    transform="translate(0.000000, -2.000000)"
                    fill="currentColor"
                    fillRule="nonzero"
                >
                    <g id="UI-:-Action-:-Compare" transform="translate(0.000000, 2.187500)">
                        <path d="M1.5625,0 L0.3125,0 C0.139765739,0 0,0.139843822 0,0.3125 L0,1.5625 C0,1.73523426 0.139765739,1.875 0.3125,1.875 L1.5625,1.875 C1.73515618,1.875 1.875,1.73437476 1.875,1.5625 L1.875,0.3125 C1.875,0.139843822 1.73515618,0 1.5625,0 Z M1.5625,3.125 L0.3125,3.125 C0.139765739,3.125 0,3.26562494 0,3.4375 L0,4.6875 C0,4.86023426 0.139765739,5 0.3125,5 L1.5625,5 C1.73515618,5 1.875,4.85937476 1.875,4.6875 L1.875,3.4375 C1.875,3.26562494 1.73515618,3.125 1.5625,3.125 Z M1.5625,6.25 L0.3125,6.25 C0.139765739,6.25 0,6.39062524 0,6.5625 L0,7.8125 C0,7.98523426 0.139765739,8.125 0.3125,8.125 L1.5625,8.125 C1.73515618,8.125 1.875,7.98437476 1.875,7.8125 L1.875,6.5625 C1.875,6.39062524 1.73515618,6.25 1.5625,6.25 Z M3.75,1.5625 L9.375,1.5625 C9.72011745,1.5625 10,1.28261685 10,0.955078006 C10,0.627539158 9.72070336,0.3125 9.375,0.3125 L3.75,0.3125 C3.40429693,0.3125 3.125,0.592383146 3.125,0.919921994 C3.125,1.24746084 3.40429693,1.5625 3.75,1.5625 Z M9.375,6.5625 L3.75,6.5625 C3.40488285,6.5625 3.125,6.84238255 3.125,7.1875 C3.125,7.53261745 3.40488285,7.8125 3.75,7.8125 L9.375,7.8125 C9.72011745,7.8125 10,7.53261745 10,7.1875 C10,6.84238255 9.72070336,6.5625 9.375,6.5625 Z M9.375,3.4375 L3.75,3.4375 C3.40429693,3.4375 3.125,3.71679693 3.125,4.0625 C3.125,4.40820336 3.40488285,4.6875 3.75,4.6875 L9.375,4.6875 C9.72011745,4.6875 10,4.40761745 10,4.0625 C10,3.71738255 9.72070336,3.4375 9.375,3.4375 Z"></path>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconList);
